<p-dialog #dialog [(visible)]="visible" [draggable]="false" (onHide)="onHide()" (onShow)="onShow()" [modal]="true" [resizable]="false" [closable]="false" [style]="{width: width}">
    <ng-template pTemplate="header">
        <div class="text-center">
            <span class="color-danger fz-x2"><i aria-hidden="true" [class]="icon"></i></span>
            <ng-content select="h2,h3,h4"></ng-content>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <ng-content></ng-content>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-content select="footer"></ng-content>
    </ng-template>
</p-dialog>